import BaseModule from './base-module';

// 用户
class Member extends BaseModule {
  // 用户列表
  userList(params) {
    return this.post('/admin/i_lis/userList', params);
  }
  // 新用户列表
  newUserList(params) {
    return this.post('/admin/i_lis/getNewMember ', params);
  }
  // 欠款用户列表
  owingUserList(params) {
    return this.post('/admin/i_lis/getOweUser ', params);
  }
  // 用户还款
  repay(params) {
    return this.post('/admin/i_lis/repay ', params);
  }
  // 用户详情
  userDetail(params) {
    return this.post('/admin/i_lis/userDetail', params);
  }
  // 用户地址列表
  userAddressList(params) {
    return this.post('/admin/i_lis/userAddress', params);
  }
  // 用户账单列表
  userBills(params) {
    return this.post('/admin/i_lis/recordList', params);
  }
  // 下载账单
  downLoadUserBills(params) {
    return this.post('/admin/i_lis/getUserMonthCountDetail', params);
  }
  // 用户账单信息
  billsInfo(params) {
    return this.post('/admin/i_lis/getUserMonthCount', params);
  }
  // 用户还款记录
  repayBills(params) {
    return this.post('/admin/i_lis/repayList', params);
  }
  // 用户还款方式
  repayMethod(params) {
    return this.post('/admin/i_lis/getRepayMethod', params);
  }
  // 用户还款到账银行
  repayBank(params) {
    return this.post('/admin/i_lis/getBank', params);
  }
  // 充值
  userDeposit(params) {
    return this.post('/admin/i_lis/rechargeAmount', params);
  }
  setUserLevel(params) {
    return this.post('/admin/i_lis/setUserLevel', params);
  }
  // 成员列表
  memberList(params) {
    return this.post('/admin/i_lis/memberList', params);
  }
  // 修改账号
  updateUsername(params) {
    return this.post('/admin/i_lis/updateAccount', params);
  }
  // 修改密码
  updatePassword(params) {
    return this.post('/admin/i_lis/updatePassword', params);
  }

  // 管理员扣款接口
  subtractAmount(params) {
    return this.post('/admin/i_lis/subtractAmount', params);
  }
}

export default new Member();
